export const translationsEn = {
    "message1" : "Hello in english",
    "home.watch.the.film":"Watch the film",
    'home.raison.etre': "Discover our raison d'être",
    'close': 'Close'
}